import { ReverseMoney } from './ReverseMoney';

export enum LineStatus {
  NA = 'NA',
  SUBMITTED = 'Submitted',
  CREDIT_NOTE = 'CreditNote',
  BILLED = 'Billed',
  REFUSED = 'Refused',
}

export interface InterventionReportLineSummary {
  id: string;
  type: string;
  description?: string;
  preTaxUnitPrice?: ReverseMoney;
  vatRate?: number;
  preTaxAmount?: ReverseMoney;
  amountIncludedTax?: ReverseMoney;
  recipientType?: string;
  recipientId?: string;
  recipientName?: string;
  isBilled?: boolean;
  sparePartSupplierName?: string;
  sparePartReference?: string;
  sparePartPreTaxPurchasePrice?: ReverseMoney;
  serviceUniqueName?: string;
  billingNumber?: string;
  billCreationDate?: Date;
  serviceLabel?: string;
  status?: LineStatus;
}

export interface InterventionReportSummary {
  interventionReportId: string;
  creationDateUtc: string;
  fileId?: string;
  fileReference?: string;
  orderMission?: string;
  modelType?: string;
  localizedModelType?: string;
  model?: string;
  brand?: string;
  reasonName?: string;
  warrantyType?: string;
  localizedWarrantyType?: string;
  localizedReason?: string;
  factoryCode?: string;
  serialNumber?: string;
  technicalComment?: string;
  comment?: string;
  sellerId: string;
  seller?: string;
  closingType: string;
  validatorUserName?: string;
  irisCode?: string;
  preTaxAmount: ReverseMoney;
  lineCount: number;
  lines: InterventionReportLineSummary[];
}
